<app-nav></app-nav>
<div
  class="page-body-config"
  role="main"
>
  <!-- Submit Success -->
  <ng-container *ngIf="interviewRequestSubmitted">
    <header>
      <h1 class="page-header">Submit Success</h1>
    </header>
    <div class="inner-content mx-auto pt-5">
      <div class="content mx-auto">
        <app-interview-request-submitted
          [showCamperApplication]="showReleaseFormsError"></app-interview-request-submitted>
      </div>
    </div>
  </ng-container>

  <!-- Interview Request Form -->
  <ng-container *ngIf="!interviewRequestSubmitted">
    <header>
      <h1 class="page-header">Interview Request</h1>
    </header>
    <div id="main-content">
      <mat-tab-group
        class="left-stepper"
        [disableRipple]="true"
        [@.disabled]="true"
        [(selectedIndex)]="currIndex"
      >
        <!-- Step 1 -->
        <mat-tab
          label="Dog(s)"
          [disabled]="!enabledTabs.has(0)"
        >
          <div class="inner-content">
            <div class="content mx-auto">
              <app-step-one
                #stp1Form
                (navigateToStepTwo)="navigateToTabIndex(1, true)"
              ></app-step-one>
            </div>
          </div>
        </mat-tab>

        <!-- Step 2 -->
        <mat-tab
          label="Submit"
          [disabled]="!enabledTabs.has(1)"
        >
          <div class="inner-content">
            <div class="content mx-auto">
              <app-step-two
                #stp2Form
                [tabIndexPrompt]="currIndex"
                (submitted)="handleRequestSubmitted()"
              ></app-step-two>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </ng-container>
</div>
<app-footer></app-footer>
